import { qs, qsAll } from '../dom-helpers';
import Abstract from './class.Abstract';

class Policies {
  constructor() {
    if (!qs('.page-template-policies-template')) return;

    this.TAB_ACTIVE_CLASS = 'policy__nav-button--active';
    this.CONTENT_BLOCK_CLASS = 'desk-box';

    this.urlHash = decodeURI(location.hash.replace('#', ''));

    this._run();
    this._initEvents();
  }

  _run() {
    this.tabs = qsAll('.policy__nav-button[data-index]');
    this.contentBlocks = qsAll(`.${this.CONTENT_BLOCK_CLASS}[data-index]`);
  }

  _initEvents() {
    this.tabs.forEach((tab) => {
      /*
      * Functional for switch tabs from other pages
      * Functional automatic search the same tab and activate it without dependency of current language
      * setTimeout is needed for correct work, whitout it does not work
      */
      if (this.urlHash && this.urlHash === tab.dataset.id.toLowerCase()) {
        setTimeout(() => this._change(tab, 'link'), 1500);
      }

      tab.addEventListener('click', (e) => this._change(e));
    });
  }

  _change(e, link) {
    const tab = link ? e : e.target;
    const index = tab.dataset.index;
    const id = tab.dataset.id.toLowerCase().replace(' ', '_');

    this._removeOldActiveStates();
    this._changeUrlHash(id);
    this._addNewActiveStates(tab, index);
  }

  _removeOldActiveStates() {
    Abstract.findClassNameAndRemove(this.TAB_ACTIVE_CLASS);
    this.contentBlocks.forEach((contentBlock) => Abstract.fadeOut(contentBlock));
  }

  _addNewActiveStates(tab, index) {
    tab.classList.add(this.TAB_ACTIVE_CLASS);
    const activeContentBlock = qs(`.${this.CONTENT_BLOCK_CLASS}[data-index="${index}"]`);
    Abstract.fadeIn(activeContentBlock);
  }

  _changeUrlHash(id) {
    location.hash = `#${id}`;
  }
}

export default Policies;
